module.exports = __webpack_public_path__ + "static/media/austin.3bbacb70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/austin.jpg
// module id = 56
// module chunks = 0